import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ProductsGrid from "@/components/ProductsGrid";
import Automation from "@/components/Automation";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <ProductsGrid />
      <Automation />
    </div>
  );
}
